export default __webpack_public_path__ + "static/pvsindhu-img-45f10e69e49fc2e46c00cd458a3d5d33.png";